// extracted by mini-css-extract-plugin
export var chip = "_2q-9";
export var chipLabel = "_2q-a";
export var close = "_2q-7";
export var closeIcon = "_2q-8";
export var error = "_2q-6";
export var infoTooltip = "_2q-2";
export var innerContainer = "_2q-1";
export var input = "_2q-b";
export var medium = "_2q-5";
export var outerContainer = "_2q-0";
export var small = "_2q-4";
export var xSmall = "_2q-3";